var React = require('react');

function DarkMode (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M13.5695 10.2362C12.8784 10.514 12.1237 10.6668 11.3333 10.6668C8.01962 10.6668 5.33333 7.9805 5.33333 4.66679C5.33333 3.87641 5.48616 3.12172 5.76387 2.43066C3.55766 3.31728 2 5.4768 2 8.00012C2 11.3138 4.68629 14.0001 8 14.0001C10.5233 14.0001 12.6828 12.4425 13.5695 10.2362Z"}));
}

DarkMode.defaultProps = {"width":"16","height":"16","viewBox":"0 0 16 16","fill":"#6464E9"};

module.exports = DarkMode;

DarkMode.default = DarkMode;
